import { FC, PropsWithChildren, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { doesExist } from 'utils/tsHelpers';
import { InputText, InputTextProps } from 'ui/inputs';
import { colors, spacing, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const EmptyPillInput = styled.div`
  ${body2};
  border-radius: ${spacing.quarter};
  border: 1px dashed ${colors.grey15};
  color: ${colors.textSecondary};
  cursor: pointer;
  padding: ${spacing.threeEights} ${spacing.fiveEights};
  display: flex;
  align-items: center;
  :hover {
    border: 1px dashed ${colors.grey50};
    color: ${colors.purple100};
  }
`;

const InputWrapper = styled.div`
  & {
    &:hover {
      input {
        color: ${colors.purple100} !important;
      }
    }
    &[data-full='true'] {
      > div {
        background: ${colors.purple10};
        border: 1px solid transparent;
        &:hover {
          border: 1px solid ${colors.purple50};
        }
      }
    }
  }
`;
const FilledPillInput = styled(InputText)`
  && {
    > input {
      width: ${pxToRem(30)};
      &:hover {
        color: ${colors.purple100};
      }
      &[data-fullwidth='true'] {
        width: ${pxToRem(150)};
      }
      &[data-full='true'] {
        background-color: ${colors.purple10};
        color: ${colors.purple70};
        box-shadow: 0 0 0 ${spacing.single} transparent;
        box-shadow: none;
      }
    }
  }
`;

export const PurpleInputEmptyField = 'purple-input-empty-field';
export type PurpleInputProps = {
  children?: ReactNode;
} & InputTextProps;
export const PurpleInput: FC<PropsWithChildren<PurpleInputProps>> = (props) => {
  const [isTextMode, setIsTextMode] = useState(false);
  const { value } = props;
  const hasValue = doesExist(value) && value !== '';
  if (hasValue || isTextMode) {
    return (
      <InputWrapper data-full={hasValue}>
        <FilledPillInput
          {...props}
          onBlur={() => {
            if (!hasValue) {
              setIsTextMode(false);
            }
          }}
          autoFocus={!hasValue}
          data-full={hasValue}
        />
      </InputWrapper>
    );
  }
  return (
    <EmptyPillInput data-test={PurpleInputEmptyField} onClick={() => setIsTextMode(true)}>
      Enter a value
    </EmptyPillInput>
  );
};
